import React, { useState } from 'react';

import Authentication from "api/Authentication";
import { useNavigate, useParams } from 'react-router-dom';

import {
  LOGOUT,
} from "../../actions/types";
import { connect } from "react-redux";
import messageSlice from 'redux/messageSlice';
import CookieHelper from "helpers/cookie";

class Logout extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,validation: false};
		this.dispatch = this.props.dispatch;
	}
  
	async componentDidMount() {
				let rawCookie = CookieHelper.getCookie("mmev_obj");
				
		if(typeof rawCookie == 'undefined') {
			this.dispatch(messageSlice.actions.submitMessage({action: LOGOUT }));
	
			
			//this.props.router.replace('/')
			//window.location.reload();	
			}
			let response = await Authentication.logoutUser();
			this.dispatch({ type: LOGOUT });
			this.props.navigate('/login');
	}

	render() {
		return null;
	}
}

const LogoutInit = (props) => {
	let navigate = useNavigate();
	const params = useParams();
	//return (React.createElement(ComponentName, {...props, navigate:navigate, isLoggedIn: false}))
	//return (<Compo {...props} navigate={navigate}/>)
	return (<Logout {...props} navigate={navigate} {...params}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(LogoutInit);
